import { defaultRegion2Langs } from 'components/Langs/langs';
import { atom, useAtomValue, useSetAtom } from 'jotai';

const regionLanguageMapRef = {
  current: Object.keys(defaultRegion2Langs).reduce(
    (res, region) => {
      res[region] = defaultRegion2Langs[region].defaultValue;
      return res;
    },
    {
      FACEBOOK: 'en-US',
    } as Record<General.UpperCaseRegion | 'FACEBOOK', General.Language>,
  ),
};

type MapValue = Record<General.UpperCaseRegion | 'FACEBOOK', General.Language>;

const regionLanguageMapState = atom<MapValue>(regionLanguageMapRef.current);

const writeAtome = atom(null, (get, set, value: MapValue | ((value: MapValue) => MapValue)) => {
  const cur = get(regionLanguageMapState);
  const next = typeof value === 'function' ? value(cur) : value;
  regionLanguageMapRef.current = next;
  set(regionLanguageMapState, next);
});

export const useRegionLanguageMap = () => useAtomValue(regionLanguageMapState);
export const useSetRegionLanguageMap = () => useSetAtom(writeAtome);

export const getRegionLanguageMap = () => regionLanguageMapRef.current;
